import {
  Box,
  SliderFilledTrack,
  Slider,
  SliderThumb,
  SliderTrack,
  Tooltip,
  // Tooltip,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';

type Props = {
  min: number;
  max: number;
  step: number;
  baseValue: number;
  onChange?: (value: number) => void;
  onChangeEnd: (value: number) => void;
};

const RoundSlider = ({
  min,
  max,
  step,
  baseValue,
  onChange,
  onChangeEnd,
}: Props) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [currentValue, setCurrentValue] = useState(baseValue);

  useEffect(() => {
    setCurrentValue(baseValue);
  }, [baseValue]);

  return (
    <Box w="full">
      <Slider
        step={step}
        min={min}
        max={max}
        value={currentValue}
        focusThumbOnChange={false}
        onChange={(v) => {
          setCurrentValue(v);
          onChange?.(v);
        }}
        onChangeEnd={onChangeEnd}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <SliderTrack bg="reno.grey400">
          <Box position="relative" right={10} />
          <SliderFilledTrack bg="primaryColor" />
        </SliderTrack>
        <Tooltip
          hasArrow
          bg="primaryColor"
          color="white"
          placement="top"
          isOpen={showTooltip}
          label={currentValue}
        >
          <SliderThumb bg="primaryColor" boxSize={6} />
        </Tooltip>
      </Slider>
    </Box>
  );
};

// import { useEffect, useRef, useState } from 'react';

// const { RadiaSlider } = require('@maslick/react-radiaslider');
// import CircularSlider from '@maslick/radiaslider';

// TOP:  https://www.npmjs.com/package/@fseehawer/react-circular-slider
// ==> Not compatible with react 17

// https://www.npmjs.com/package/@maslick/react-radiaslider
// ==> 2 years old

// https://jsdev63.github.io/advanced_react-circular-slider/

// const RoundSlider = () => {
//   const canvasRef = useRef<HTMLCanvasElement>(null);
//   const canvasID = 'slider-canvas';
//   const [context, setContext] = useState<CanvasRenderingContext2D | null>(null);

//   console.log(RadiaSlider);

//   // CHECK THIS :
//   // https://codepen.io/MyXoToD/pen/xGRrgQ

//   // check this one
//   // https://roundsliderui.com/demos.html

//   useEffect(() => {
//     if (canvasRef.current) {
//       const renderCtx = canvasRef.current.getContext('2d');
//       // alert(document.getElementById(canvasID));
//       if (renderCtx) {
//         setContext(renderCtx);
//       }
//     }
//   }, [context]);

//   return (
//     <>
//       <canvas id={canvasID} ref={canvasRef} />
//       <div>test</div>
//       {canvasRef.current && context && (
//         <>
//           <div>done</div>
//           <RadiaSlider
//             id={canvasID}
//             canvasId={canvasID}
//             radius={50}
//             min={0}
//             max={30}
//             step={1}
//             color="#104b63"
//             continuousMode
//             x0={10}
//             y0={10}
//             readOnly={false}
//             startAngle={20}
//             endAngle={180}
//             // r={50}
//             // trackWidth={10}
//             // thumbWidth={10}
//             // onChange={(value: any) => console.log(value)}
//           />
//         </>
//       )}
//     </>
//   );
// };
export default RoundSlider;
